module.exports = __webpack_public_path__ + "img/00035.756c2dcd.webp";